import { useIOSRedirect } from '@/shared/hooks/useIOSRedirect';

const APP_STORE_URL = 'https://apps.apple.com/app/id6736533773';

interface IOSRedirectGuardProps {
  children: React.ReactNode;
}

export function IOSRedirectGuard({ children }: IOSRedirectGuardProps) {
  const { isIOS, wasRedirected } = useIOSRedirect();

  if (isIOS && wasRedirected) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-[#1B2559] via-[#2A3F8F] to-[#1B2559] px-6 text-center">
        <div className="animate-pulse">
          <h1 className="text-2xl font-bold text-white">Opening ChartAI...</h1>
          <p className="mt-3 text-blue-200/80">Redirecting you to the app</p>
        </div>
        <div className="mt-10">
          <p className="text-sm text-blue-300/60">Not redirected?</p>
          <a
            href={APP_STORE_URL}
            className="mt-2 inline-block rounded-lg bg-white px-6 py-2.5 text-sm font-medium text-[#1B2559] transition-opacity hover:opacity-90"
          >
            Open in App Store
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
